import React from 'react';
import './App.css';
import './animista.min.css';
import { BrowserRouter as Router, Switch, Route } from 'react-router-dom';
import AutoPlayComponent from './AutoPlay/AutoPlayComponent';

class App extends React.Component {
  render() {
    return (
      <Router>
        <div className="App">
          <Switch>
            <Route path="/" component={AutoPlayComponent} />
        </Switch>
      </div>
    </Router>
    );
  }
}

export default App;
